var map = {
	"./pipl-k11-general-pipl-en.vue": [
		"98ff",
		"chunk-32e74977"
	],
	"./pipl-k11-minor-pipl-en.vue": [
		"b6c8",
		"chunk-27cbf811"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "af1b";
module.exports = webpackAsyncContext;